import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../_virtual/_rollupPluginBabelHelpers.mjs';
import styled, { css } from 'styled-components';

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
function px2rem(value) {
  if (value === 0) {
    return "0";
  }
  if (Math.abs(value) <= 1) {
    return "".concat(value, "px");
  }
  return "".concat(Math.round(value * 0.1 * 1000) / 1000, "rem");
}
var sizeMap = new Map([["xs", 18], ["s", 24], ["m", 36], ["l", 48], ["xl", 64]]);
var TouchWrapper = styled.span.attrs(function (props) {
  var _props$ariaLabel;
  return {
    role: "button",
    "aria-label": (_props$ariaLabel = props["aria-label"]) !== null && _props$ariaLabel !== void 0 ? _props$ariaLabel : "button"
  };
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n\n  ", "\n"])), function (props) {
  var presetSize = sizeMap.get(props.size);
  if (!presetSize) {
    return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        width: ", ";\n        height: ", ";\n      "])), px2rem(props.touch), px2rem(props.touch));
  }
  var gap = Math.round((props.touch - presetSize) / 2);
  return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      margin: ", ";\n    "])), px2rem(gap));
});
var SizeWrapper = styled.span(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n\n  ", "\n\n  svg {\n    width: 100%;\n    height: 100%;\n  }\n"])), function (props) {
  var presetSize = sizeMap.get(props.size);
  return css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n      width: ", ";\n      height: ", ";\n    "])), presetSize ? px2rem(presetSize) : props.size, presetSize ? px2rem(presetSize) : props.size);
});

export { SizeWrapper, TouchWrapper };
